import { render, staticRenderFns } from "./JLinkAddress.vue?vue&type=template&id=231ccfee"
import script from "./JLinkAddress.vue?vue&type=script&lang=js"
export * from "./JLinkAddress.vue?vue&type=script&lang=js"
import style0 from "./JLinkAddress.vue?vue&type=style&index=0&id=231ccfee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports